module.exports = __webpack_public_path__ + "img/00008.54a77c09.webp";